var $name="isUsingKeyboard",$path="app/utilities/isUsingKeyboard.js",$this={$name,$path,};import { css } from 'configs';

export default function isUsingKeyboard() {
  return document.body.classList.contains(css.classNames.keyboard);
}
